import React from 'react';

const statusMap = {
  Active: 'bg-green-50 text-green-700 border border-green-200',
  Posted: 'bg-green-50 text-green-700 border border-green-200',
  Approved: 'bg-green-50 text-green-700 border border-green-200',
  Finalised: 'bg-green-50 text-green-700 border border-green-200',
  Completed: 'bg-green-50 text-green-700 border border-green-200',
  Complete: 'bg-green-50 text-green-700 border border-green-200',
  Accepted: 'bg-green-50 text-green-700 border border-green-200',
  Confirmed: 'bg-green-50 text-green-700 border border-green-200',
  Delivered: 'bg-green-50 text-green-700 border border-green-200',
  Reconciled: 'bg-green-50 text-green-700 border border-green-200',
  'Posted to Wallet': 'bg-green-50 text-green-700 border border-green-200',
  'Charge Approved': 'bg-green-50 text-green-700 border border-green-200',
  'Option Approved': 'bg-green-50 text-green-700 border border-green-200',
  Done: 'bg-green-50 text-green-700 border border-green-200',
  'Active Hold': 'bg-blue-50 text-blue-700 border border-blue-200',
  'In Progress': 'bg-blue-50 text-blue-700 border border-blue-200',
  'Design In Progress': 'bg-blue-50 text-blue-700 border border-blue-200',
  'In Production': 'bg-blue-50 text-blue-700 border border-blue-200',
  'Under Review': 'bg-blue-50 text-blue-700 border border-blue-200',
  'Under Brand Review': 'bg-blue-50 text-blue-700 border border-blue-200',
  'Submitted to Brand': 'bg-blue-50 text-blue-700 border border-blue-200',
  'Submitted for Approval': 'bg-blue-50 text-blue-700 border border-blue-200',
  Submitted: 'bg-blue-50 text-blue-700 border border-blue-200',
  Dispatched: 'bg-blue-50 text-blue-700 border border-blue-200',
  Pending: 'bg-amber-50 text-amber-700 border border-amber-200',
  'Awaiting Brand Approval': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Awaiting Brand Review': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Estimate Pending': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Charge Pending': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Needs More Information': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Low Balance': 'bg-amber-50 text-amber-700 border border-amber-200',
  Onboarding: 'bg-amber-50 text-amber-700 border border-amber-200',
  Incomplete: 'bg-amber-50 text-amber-700 border border-amber-200',
  Draft: 'bg-gray-100 text-gray-600 border border-gray-200',
  Rejected: 'bg-red-50 text-red-700 border border-red-200',
  Suspended: 'bg-red-50 text-red-700 border border-red-200',
  'Insufficient Balance': 'bg-red-50 text-red-700 border border-red-200',
  'More Options Requested': 'bg-orange-50 text-orange-700 border border-orange-200',
  Cancelled: 'bg-gray-100 text-gray-500 border border-gray-200',
  Ready: 'bg-teal-50 text-teal-700 border border-teal-200',
};

const variantStyles = {
  green: 'bg-[#E8F5EE] text-[#1A6B3E] border-[#A8DEC0]',
  amber: 'bg-[#FEF3E2] text-[#92560C] border-[#F7C97A]',
  red: 'bg-[#FDECEA] text-[#C0222B] border-[#F5A9AC]',
  indigo: 'bg-[#EEF0FB] text-[#3D52A0] border-[#B8C1E8]',
  purple: 'bg-[#F0EBFF] text-[#5B21B6] border-[#C4B5FD]',
  teal: 'bg-[#E6F7F7] text-[#0C6E6E] border-[#81D4D4]',
  navy: 'bg-[#1E2A3B] text-white border-transparent',
  gray: 'bg-[#F4F3F0] text-[#5C5A54] border-[#E5E3DE]',
  blue: 'bg-[#EFF6FF] text-[#1D4ED8] border-[#BFDBFE]',
};

export const statusToBadge = (statusStr) => {
  if (!statusStr) return 'gray';
  const map = {
    active: 'green', approved: 'green', confirmed: 'green', delivered: 'green',
    posted: 'green', finalised: 'green', closed: 'green', acknowledged: 'green',
    completed: 'green', good: 'green',
    pending: 'amber', 'under review': 'amber', 'in transit': 'amber', onboarding: 'amber',
    hold: 'amber', held: 'amber', 'in production': 'amber', 'estimate pending': 'amber',
    draft: 'gray', 'not started': 'gray', backlog: 'gray', archived: 'gray',
    rejected: 'red', disputed: 'red', damaged: 'red', cancelled: 'red', insufficient: 'red',
    suspended: 'red', 'on hold': 'red',
    'design approval': 'purple', design: 'purple',
    submitted: 'indigo', accepted: 'indigo', 'submitted for approval': 'indigo',
    dispatched: 'teal', 'posted to wallet': 'teal',
    'clarification required': 'amber', 'more options requested': 'amber',
    'charge pending': 'amber', 'awaiting brand approval': 'amber',
    'needs more information': 'amber', 'estimate approved': 'blue',
  };
  return map[String(statusStr).toLowerCase()] || 'gray';
};

export function Badge({ status, variant, size = 'sm', dot, children, className = '' }) {
  if (variant || children !== undefined) {
    const vStyle = variantStyles[variant] || variantStyles.gray;
    return (
      <span className={`inline-flex items-center gap-1.5 border font-medium rounded-full ${
        size === 'sm' ? 'px-2 py-0.5 text-[10px] tracking-wide uppercase' : 'px-2.5 py-1 text-xs'
      } ${vStyle} ${className}`}>
        {dot && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />}
        {children || status}
      </span>
    );
  }

  const styles = statusMap[status] ?? 'bg-gray-100 text-gray-600 border border-gray-200';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium ${styles} ${className}`}>
      {status}
    </span>
  );
}

export default Badge;
